import { useEffect } from 'react';
var DEFAULT_USE_TITLE_OPTIONS = {
  restoreOnUnmount: false
};
var originTitle = '';
var originLink = null;
var titleCount = 0;
var linkCount = 0;

function useTitle(title, link) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_USE_TITLE_OPTIONS;
  useEffect(function () {
    var headIcon = document.querySelector('link[rel="icon"]');

    if (!originTitle && !originLink && titleCount === 0 && linkCount === 0) {
      originTitle = document.title;

      if (link) {
        if (headIcon !== null) {
          originLink = headIcon.href;
        }
      }
    }

    document.title = title;
    titleCount += 1;

    if (link) {
      if (headIcon !== null) {
        headIcon.href = link; // Otherwise, create a new element and append it to <head>.
      } else {
        headIcon = document.createElement('link');
        headIcon.rel = 'icon';
        headIcon.href = link;
        document.head.appendChild(headIcon);
      }

      linkCount += 1;
    }

    return function () {
      if (options && options.restoreOnUnmount) {
        titleCount -= 1;
        titleCount === 0 && (document.title = originTitle);

        if (link) {
          linkCount -= 1;
          linkCount === 0 && (originLink ? headIcon.href = originLink : document.head.removeChild(headIcon));
        }
      }
    };
  }, [title, link, options]);
}

function reSet() {
  originLink = null;
  originTitle = '';
  titleCount = 0;
  linkCount = 0;
  document.title = '';
  var headIcon = document.querySelector('link[rel="icon"]');
  headIcon && document.head.removeChild(headIcon);
}

useTitle.reSet = reSet;
export default useTitle;